import {
  ascend,
  chain,
  concat,
  map,
  pathOr,
  pipe,
  prop,
  sort,
  uniq
} from 'ramda';
import { createSelector } from 'reselect';
import { MODE } from '../../../constants';
import { useSportsbookSelector } from '../../store';

export const selectCyberSportTournamentsIdsByCategoryId = (categoryId) =>
  createSelector(
    pathOr({}, ['tournaments', MODE.PRE_MATCH, 'data']),
    pathOr({}, ['tournaments', MODE.IN_PLAY, 'data']),
    pathOr([], ['tournaments', MODE.PRE_MATCH, 'ids']),
    pathOr([], ['tournaments', MODE.IN_PLAY, 'ids']),
    (preMatchData, liveData, preMatchIds, liveIds) => {
      // Since we need to achieve sorted list by merging two sorted lists which has items with identical weight we have to assume a number of things:
      //  1) both lists are initially properly sorted
      //  2) items with same tournamentId are same items
      //  3) sorting in both lists DOES NOT contradict each other (because if it does - this problem has no solution)
      // 4) live tournaments have preference over preMatch ones

      const filterMapTournaments = (id) => {
        const tournament = liveData[id] ?? preMatchData[id];

        if (!tournament || tournament.categoryId !== categoryId) {
          return [];
        }

        return tournament;
      };

      return pipe(
        concat(preMatchIds),
        uniq,
        chain(filterMapTournaments),
        sort(ascend(prop('tournamentWeigh'))),
        map(prop('tournamentId'))
      )(liveIds);
    }
  );

export const useCyberSportTournamentsIdsByCategoryId = (categoryId) =>
  useSportsbookSelector(selectCyberSportTournamentsIdsByCategoryId, [
    categoryId
  ]);
